export default "__VITE_ASSET__CGcqPBHc__"